<template>
    <div :class="{
            'update-info-post position-absolute' : true,
            'update-info-post-mobile' : $detect == 'mobile'
        }">
        <div :class="{
                    'edit-post offset-6 col-6 pl-2 pr-0' : true,
                    'm-0 col-12' : $detect == 'mobile'
                }" v-loading="loading">
            <div class="card-dashboard">
                <div class="py-10px px-3 border-bottom border-primary title-popup-mobile">
                    <span class="mb-0">Chỉnh sửa thông tin</span>
                    <div class="close" role="button" @click="updateCheck = 0">
                        <i class="icon ion-md-close" v-if="$detect == 'web'"></i>
                        <i class="icon ion-ios-arrow-back" v-if="$detect == 'mobile'"></i>
                    </div>
                </div>
                <div class="content p-3">
                    <div class="d-flex mt-3">
                        <div class="w-title">Tiêu đề:</div>
                        <div class="w-value">
                            <input type="text" class="input-vg" disabled="disabled" v-model="form.name"/>
                            <div class="err-form-uptdate fs-12px text-danger ml-1" v-if="error.name">
                                {{error.name}}
                            </div>
                        </div>
                    </div>
                    <div class="d-flex mt-3">
                        <div class="w-title">SKU:</div>
                        <div class="w-value">
                            <input type="text" class="input-vg" v-model="form.sku" @keyup.enter="submit" placeholder="Nhập mã SKU" />
                            <div class="err-form-uptdate fs-12px text-danger ml-1" v-if="error.sku" v-html="error.sku"></div>
                        </div>
                    </div>
                    <div class="d-flex mt-3">
                        <div class="w-title">Giá:</div>
                        <div class="w-value">
                            <div class="input-icon">
                                <input type="text" class="input-vg text-danger" @keyup.enter="submit" inputmode="numeric" v-model="form.price"
                                    @input="formatPrice()" @focus="(e) => e.target.select()"/>
                                <span class="text-danger">VNĐ</span>
                            </div>
                            <div class="err-form-uptdate fs-12px text-danger ml-1" v-if="error.price">
                                {{error.price}}
                            </div>
                            <!-- <div v-else class="suggest err-form-uptdate fs-12px  ml-1">Sản phẩm này có giá trị trung bình là {{form.price_medium}} đ</div> -->
                        </div>
                    </div>
                    <div class="d-flex mt-3">
                        <div class="w-title">Thuế:</div>
                        <div class="w-value lh-40">
                            <div class="form-check form-check-inline w-100">
                                <input class="form-check-input" type="checkbox" id="tc_nb" :value="0" @keyup.enter="submit" v-model="form.vat">
                                <label class="form-check-label vat" for="tc_nb">Thuế VAT</label>
                            </div>
                            <div class="err-form-uptdate fs-12px text-danger ml-1" v-if="error.vat">
                                {{error.vat}}
                            </div>
                        </div>
                    </div>
                    <div class="d-flex mt-3">
                        <div class="w-title line-height-unset">Số lượng bán ra tối thiểu:</div>
                        <div class="w-value">
                            <div class="input-icon">
                                <input type="text" class="input-vg" inputmode="numeric" @keyup.enter="submit" v-model="form.min_quality"
                                @input="formatMinQuality()" />
                            </div>
                            <div class="err-form-uptdate fs-12px text-danger ml-1" v-if="error.min_quantity">
                                {{error.min_quantity}}
                            </div>
                        </div>
                    </div>
                    <div class="d-flex mt-3">
                        <div class="w-title">Nguồn gốc:</div>
                        <div class="w-value">
                            <ldc-select
                                placeholder="Chọn trạng thái"
                                v-model="form.type">
                                <ldc-option
                                    :value="1"
                                    label="Chính hãng"/>
                                <ldc-option
                                    :value="2"
                                    label="Xách tay"/>
                                <ldc-option
                                    :value="3"
                                    label="Hàng công ty"/>
                            </ldc-select>
                        </div>
                    </div>
                    <div class="d-flex mt-3">
                        <div class="w-title">Trạng thái:</div>
                        <div class="w-value">
                            <ldc-select
                                placeholder="Chọn trạng thái"
                                v-model="form.quality">
                                <ldc-option
                                    :value="0"
                                    label="Hàng mới"/>
                                <ldc-option
                                    :value="1"
                                    label="Hàng cũ"/>
                            </ldc-select>
                        </div>
                    </div>
                    <div class="d-flex mt-3">
                        <div class="w-title">Hiện thị nút:</div>
                        <div class="w-value">
                            <span :class="'btn_rdo' + (form.quantity >= 1 && form.quantity <= 10 ? ' btn_rdo_buy' : '')" @click="selectNut(1)">Đặt mua</span>
                            <span :class="'btn_rdo ml-2' + (form.quantity == 0 ? ' btn_rdo_call' : '')" @click="selectNut(0)">Gọi điện</span>
                        </div>
                    </div>

                    <div class="d-flex mt-3">
                        <div class="w-title">Xuất xứ:</div>
                        <div class="w-value">
                             <ldc-select
                                placeholder="Chọn xuất xứ"
                                v-model="form.origin">
                                <ldc-option
                                 v-for="(index, key) in nation" :key="key"
                                    :value="index.n_id"
                                    :label="index.n_name"/>
                            </ldc-select>
                        </div>
                    </div>
                    <div class="d-flex mt-3">
                        <div class="w-title">Bảo hành:</div>
                        <div class="w-value">
                            <div class="input-icon">
                                <input type="text" class="input-vg" inputmode="numeric" @keyup.enter="submit" v-model="form.warranty"
                                    @input="formatNumb()" />
                                <span class="text">Tháng</span>
                            </div>
                            <div class="err-form-uptdate fs-12px text-danger ml-1" v-if="error.price">
                                {{error.warranty}}
                            </div>
                        </div>
                    </div>
                    <div class="d-flex mt-3">
                        <div class="w-title">Tùy chọn:</div>
                        <div class="w-value">
                            <div class="form-check form-check-inline w-100">
                                <input class="form-check-input" type="checkbox" style="appearance:auto" id="tc_nb" :value="0" v-model="form.hot">
                                <label class="form-check-label font-13px" for="tc_nb">Nổi bật</label>
                            </div>
                            <div class="form-check form-check-inline w-100">
                                <input class="form-check-input" type="checkbox" id="tc_c" style="appearance:auto" :value="0" v-model="form.new">
                                <label class="form-check-label font-13px" for="tc_c">Mới</label>
                            </div>
                            <div class="form-check form-check-inline w-100">
                                <input class="form-check-input" type="checkbox" style="appearance:auto" id="tc_km" :value="0" v-model="form.promotion">
                                <label class="form-check-label font-13px" for="tc_km">Khuyến mại</label>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex mt-3">
                        <div class="w-title">Website:</div>
                        <div class="w-value">
                            <input type="text" class="input-vg" v-model="form.website" placeholder="Website của bạn" />
                            <div class="err-form-uptdate fs-12px text-danger ml-1" v-if="error.website">
                                {{error.website}}
                            </div>
                        </div>
                    </div>
                    <div class="btn-confirm text-center mt-4">
                        <button class="btn btn btn-secondary btn-sm mr-2" @click="updateCheck = 0" v-if="$detect == 'web'">Huỷ</button>
                        <button class="btn btn-primary btn-sm ml-2" @click="submit()" >Cập nhật</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['active', 'data', 'nation'],
    components: {
        origin : () => import('@/components/profile/create/origin'),
    },
    data() {
        return {
            updateCheck: 0,
            countries: [],
            form: {},
            categories : [],
            categories_search : [],
            id_cat: [],
            keyword: '',
            timeOutStatus: null,
            activeCategory: false,
            status_category: 1,
            id: this.$route.params.id,
            loading: false,
        }
    },
    watch: {
        active(val){
            this.updateCheck = val;
        },
        updateCheck(val){
            this.$emit('update:active', val);
        },
        // keyword(val){
        //     if(val.length >= 3){
        //         this.status_category = 2;
        //         if(this.timeOutStatus) clearTimeout(this.timeOutStatus);
        //         this.timeOutStatus = setTimeout(() => {
        //             this.getCategorySearch();
        //         }, 300)
        //     }
        // },
        data: {
            handler(val){
                if(this.data){
                    this.form = {
                        price: this.$formatNumber(val.price),
                        type: val.type,
                        quality : val.quality,
                        status: val.status,
                        name: val.name,
                        warranty : val.warranty,
                        status_expire: val.status_expire,
                        sku   : val.sku,
                        hot : this.data.hot ? 1 : 0,
                        new : this.data.new ? 1 : 0,
                        promotion : this.data.promotion ? 1 : 0,
                        website    : val.website,
                        vat     : val.vat ? 1 : 0,
                        min_quality : val.min_quality,
                        quantity    : val.quantity,
                        origin : val.origin,
                    }
                }
            },
            deep: true,
        }
    },
    computed:{
        error(){
            return this.$store.state.errorPutRv;
        }
    },
    created() {
        
        if(this.data){
            this.data.price = (String) (this.data.price);
            this.form = {
                price: this.$formatNumber(this.data.price),
                type: this.data.type,
                status: this.data.status,
                name: this.data.name,
                quality : this.data.quality,
                warranty : this.data.warranty,
                status_expire: this.data.status_expire,
                sku   : this.data.sku,
                hot : this.data.hot ? 1 : 0,
                new : this.data.new ? 1 : 0,
                promotion : this.data.promotion ?  1 : 0,
                website    : this.data.website,
                vat     : this.data.vat ? 1 : 0,
                min_quality : this.data.min_quality,
                price_medium : this.data.price_medium,
                quantity    : this.data.quantity,
                origin : this.data.origin,
            }
        }
        
    },
    methods: {
        formatPrice(){
            let price = this.form.price.replace(/[^0-9]/g, '');
            this.form.price = this.$formatNumber(price)
        },
        formatNumb(){
            this.form.warranty = this.form.warranty.replace(/[^0-9]/g, '');
        },
        formatMinQuality(){
            this.form.min_quality = this.form.min_quality.replace(/[^0-9]/g, '');
        },
        formatPhone(){
            this.form.poster_phone = this.$formatNumberPhome(this.form.poster_phone)
        },
        // getCategory(parent_id = 0){
        //     apiGet('/v1/categories', {
        //         module: 'raovat',
        //         parent_id: parent_id,
        //     }).then(res => {
        //         this.categories = res.data;
        //     });
        // },
        // getChild(category) {
        //     this.getCategory(category.id);
        //     this.id_cat.push(category.id);
        // },
        // closeCategory(category) {
        //     this.form.category = {
        //         id: category.id,
        //         name: category.name
        //     }
        //     this.activeCategory = false;
        // },
        // async goBack() {
        //     let parent_id = 0;
        //     if(this.id_cat.length > 1) {
        //         parent_id = this.id_cat[this.id_cat.length -2];
        //     }
        //     await this.getCategory(parent_id);
        //     this.id_cat.splice(this.id_cat.length - 1, 1);
        // },
        // getCategorySearch() {
        //     if(this.keyword.length >= 3){
        //         apiGet('/v2/raovat/search_categories', {
        //             keyword: this.keyword
        //         }).then(res => {
        //             this.categories_search = res.data;
        //         })
        //     }
        // },
        submit(){
            let data = {
                type: this.form.type,
                price: this.$stringToNumber(this.form.price),
                name: this.form.name,
                hot : this.form.hot ? 1 : 0,
                new : this.form.new ? 1 : 0,
                promotion : this.form.promotion ? 1 : 0,
                sku    : this.form.sku,
                website    : this.form.website,
                vat     : this.form.vat ? 1 : 0,
                quality : this.form.quality,
                min_quality : this.form.min_quality,
                quantity    : this.form.quantity,
                warranty : this.form.warranty,
                execute  :    'update',
                origin : this.form.origin,
            }
            this.loading = false;
            console.log(data)
            apiPut(`/v2/profile/product/${this.id}`, data).then(res => {
                this.loading = false;
                if(res.success == 1){
                    this.$message({
                        message: 'Sửa thông tin sản phẩm thành công',
                        type: 'success',
                        center: true,
                    });
                    this.form.status = res.data.status;
                    this.emitData();
                    this.$store.commit('dataErrorPutRv', {})
                }else{
                    this.$store.commit('dataErrorPutRv', res.message.error);
                }
            }).catch(err => {
                this.loading = false;
                if(err.status == 422){
                    this.$store.commit('dataErrorPutRv', err.data);
                }
            })
        },
        selectNut(numb){
            this.form.quantity = numb; 
        },
        emitData(){
            this.$emit('dataEmit', this.form);
            this.updateCheck = 0;
        },
    }
}
</script>

<style lang="scss">
.lh-40{
    line-height: 40px;
}
.font-13px{
    font-size: 13px;
}
.line-height-unset{
    line-height: unset !important;
}
    .update-info-post {
        top: 0;
        left: 0;
        width: 100%;
        min-height: 100%;
        background: rgba(240, 245, 249, 0.8);
        input {
            &:focus {
                outline: none !important;
            }
        }
        .edit-post {
            .content {
                .w-title {
                    width: 150px;
                    font-size: 14px;
                    line-height: 40px;
                    color: #666;
                }
                .w-value {
                    width: calc( 100% - 150px );
                    .suggest{
                        color: #948c8c;
                    }
                    .btn_rdo{
                        display: inline-block;
                        background: #CCC;
                        border-radius: 3px;
                        color: #FFF;
                        height: 40px;
                        line-height: 38px;
                        opacity: 1;
                        text-align: center;
                        width: 90px;
                        border: 1px solid #CCC;
                        transition: 0.3s all;
                        box-sizing: border-box;
                        position: relative;
                        font-weight: bold;
                        margin-top: 0;
                        font-size: 16px;
                        &.btn_rdo_buy{
                            background: #F44F00;
                            border: 1px solid #F44F00;
                        }
                        &.btn_rdo_call{
                            background: #33a837;
                            border: 1px solid #33a837;
                        }
                    }
                    .vat{
                        font-size: 13px;
                    }
                    .dropdown-category {
                        border: 1px solid rgba(0, 0, 0, 0.2);
                        height: 40px;
                        line-height: 40px;
                        border-radius: 4px;
                        background: #fff;
                    }
                    [disabled] {
                        background: rgba(0, 0, 0, 0.1);
                    }
                    .ldc-input-select {
                        .ldc-input {
                            border:1px solid rgba(0, 0, 0, 0.2) !important;
                            color: #000 !important;
                        }
                    }
                    .input-icon {
                        position: relative;
                        input {
                            width: 100%;
                            background-color: white;
                            border-radius: 4px;
                            border: 1px solid rgba(0, 0, 0, 0.2);
                            padding: 0 50px 0 10px;
                            transition: border 0.2s ease-in;
                            height: 40px;
                        }
                        span {
                            font-weight: 600;
                            color: #000;
                            font-size: 14px;
                            position: absolute;
                            right: 14px;
                            top: 50%;
                            transform: translateY(-50%);
                        }
                    }
                    .err-form-uptdate {
                        margin-top: 2px;
                    }
                }
                .btn-confirm {
                    button {
                        width: 120px;
                    }
                }
            }
        }
    }
    .update-info-post-mobile {
        position: fixed !important;
        height: 100vh !important;
        .edit-post {
            padding: 0 !important;
            .card-dashboard {
                height: 100vh;
                overflow-y: auto;
                border-radius: 0 !important;
            }
            .w-title {
                width: 100px !important;
            }
            .w-value {
                width: calc( 100% - 100px ) !important;
            }
            .dropdown-category {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
        .btn-confirm {
            button {
                margin-left: 0 !important;
                height: 40px;
                width: 200px !important;
            }
        }
        .title-popup-mobile {
            background: #007bff;
            color: #fff;
            text-align: center;
            .close {
                float: left;
                i {
                    color: rgba(255, 255, 255, 1.0);
                    padding-right: 20px;
                }
            }
            span {
                margin-left: -29px;
            }
        }
    }
</style>
